import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { GapOverlapValidationPage } from './gap-overlap';
import { GridModule, RowFilterModule } from '@progress/kendo-angular-grid';
import { DirectivesModule } from '../../../directives/directives.module';
import { PtKendoModule } from '../../../_foundation/kendo/modules/pt.kendo.module';

@NgModule({
  declarations: [
    GapOverlapValidationPage
  ],
  imports: [
    IonicPageModule.forChild(GapOverlapValidationPage),
    PtKendoModule,
    GridModule,
    RowFilterModule,
    DirectivesModule,
  ],
  providers: []
})
export class GapOverlapPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/validation/gap-overlap/gap-overlap.module.ts